// import styles from './profile.module.css'
import Avatar from '@mui/material/Avatar'
import { Grid, Typography } from '@mui/material'
import StatusBtn from '../../components/atoms/status/StatusBtn'
import ButtonCustom from '../../components/atoms/button/ButtonCustom'
import DropdownMenu from '../../components/atoms/dropdown-menu/DropdownMenu'
import styles from './membersProfile.module.scss'
import { UserProfileTab } from './UserProfileTab'
const dropdownMenuOptions = [
	{ label: 'Edit', icon: <img src="/images/assign-task.svg" alt="" /> },
	{ label: 'chat', icon: <img src="/images/chat-icon.svg" alt="" /> },
	{
		label: 'Duplicate',
		icon: <img src="/images/edit-icon.svg" alt="" />,
	},
]
export const UserProfile = ({ data }) => {
	return (
		<>
			<section className={styles.pageWrp}>
				<div className={styles.profileHeader}>
					<Typography component="h1">User Profile</Typography>
				</div>
				<div className={styles.profileRow}>
					<Grid container spacing={2}>
						<Grid size={{ xs: 12, sm: 6 }}>
							<div className={styles.profileLeft}>
								<Avatar
									alt="profilePic"
									src={data.profilePic}
									sx={{ width: 96, height: 96 }}
									className={styles.avatar}
								/>
								<div className={styles.profileDetail}>
									<Typography component="h2">
										{data.firstName} {data.lastName}
									</Typography>
									<Typography>
										{data.preferredName}
									</Typography>
									{/* <StatusBtn
										label="Active"
										variant="active"
										className={styles.status}
									/> */}
								</div>
							</div>
						</Grid>
						<Grid size={{ xs: 12, sm: 6 }}>
							<div className={styles.profileRight}>
								<div className={styles.profileBtns}>
									{/* <ButtonCustom
										variant="outlined"
										to={'#'}
										size="lg"
									>
										<img src="/images/task-square.svg" />
										<Typography variant="body">
											Assign Task
										</Typography>
									</ButtonCustom>
									<ButtonCustom
										variant="default"
										to={'#'}
										size="lg"
									>
										<img src="/images/chat-icon-white.svg" />
										<Typography variant="body">
											Chat Now
										</Typography>
									</ButtonCustom>
									<ButtonCustom
										variant="outlined"
										size="lg"
										className={styles.dropdownBtn}
									>
										<DropdownMenu
											options={dropdownMenuOptions}
										/>
									</ButtonCustom> */}
								</div>
							</div>
						</Grid>
					</Grid>
				</div>
				<div className={styles.profileTab}>
					<UserProfileTab data={data} />
				</div>
			</section>
		</>
	)
}
